module.exports = __webpack_public_path__ + "img/ar_hash_next_blue.6d6df23f.svg";